import { render, staticRenderFns } from "./setPassWord.vue?vue&type=template&id=db66b466&scoped=true&"
import script from "./setPassWord.vue?vue&type=script&lang=js&"
export * from "./setPassWord.vue?vue&type=script&lang=js&"
import style0 from "./setPassWord.vue?vue&type=style&index=0&id=db66b466&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db66b466",
  null
  
)

export default component.exports